// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1RRrD","delete":"Button_delete__2wWjf","light":"Button_light__PmazV","dark":"Button_dark__2o0Ev","container":"Button_container__2fXpS"};